export default __webpack_public_path__ + "3fa28da5e9df8167c24066a0d28c7b54.jpg";